import { MainApi } from "./MainApi";
import { OrganManagerOrganSearchCondition } from "../types/organ";

export class OrganApi {
  static baseUrl = `${MainApi.urlPrefix}`;

  static getOrgans = (organManagerIdx: number, condition: OrganManagerOrganSearchCondition) => () =>
    MainApi.api.get(
      `${OrganApi.baseUrl}/organ-managers/${organManagerIdx}/organs${MainApi.toParamStringFromObject(condition)}`
    );

  static getOrganDetail = (organIdx: number) => () => MainApi.api.get(`${OrganApi.baseUrl}/organ/${organIdx}`);

  static deleteOrgan = (organIdx: number) => () => MainApi.api.delete(`${OrganApi.baseUrl}/organ/${organIdx}`);

  // 교사용AI 기관유형 권한부여(기관별): 학교용(SCHOOL_AFTERSCHOOL)/센터용(TRAINING_CENTER)
  static getOrganTeacherConfig = (organIdx: number) => () =>
    MainApi.api.get(`${OrganApi.baseUrl}/organ/${organIdx}/teacher-config`);

  static updateOrganTeacherConfig = (organIdx: number, orgType: string) => () =>
    MainApi.api.put(`${OrganApi.baseUrl}/organ/${organIdx}/teacher-config`, { orgType });
}
